<template>
  <moment :class-id="classId" :mon-types="monTypes" @back='goBack'></moment>
</template>

<script>
  export default {
    name: "TeacherWonderful",
    data() {
      const monTypes = [
        {
          text: "精彩瞬间",
          val: "wonder",
          ajaxParam: '',
          componentPath: 'components/Moment/MomentList/Moments/AllMoment'
        },
        {
          text: "我的瞬间",
          val: "my",
          ajaxParam: "Individual",
          componentPath: 'components/Moment/MomentList/Moments/MyMoment'
        }
      ];
      return {
        monTypes,
        classId: this.$route.query.c_id
      };
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      }
    },
    components: {
      moment: () => import("@/components/Moment/Moment")
    }
  };
</script>
